import React from "react";

export default function SQL_Exercises() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Exercises</h1>
      <p>This is the SQL_Exercises component generated from the SQL JSON.</p>
    </div>
  );
}
